import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6b4237a6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    id: "data-ingestion-history",
    class: "data-ingestion-history"
};
import { ref, reactive, computed, onMounted, onBeforeUnmount, watch } from 'vue';
import bus from '@/helpers/events/bus';
import { fetchDataIngestionHistory } from '@/features/DataIngestionHistory/services';
import DataIngestionHistoryMenu from '@/features/DataIngestionHistory/components/DataIngestionHistoryMenu.vue';
import DataIngestionHistoryCard from '@/features/DataIngestionHistory/components/DataIngestionHistoryCard.vue';
import BaseLoader from '@/components/_atoms/BaseLoaderSpinner.vue';
import { useStore } from 'vuex';
import { useMixpanelDataIngestionHistory } from '@/utilities/mixpanel/dataIngestionHistory';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DataIngestionHistory',
    setup(__props) {
        const isLoading = ref(false);
        const hasError = ref(false);
        const loadingExport = ref(false);
        const store = useStore();
        const state = reactive({
            data: {},
            columns: [],
            item: ['', {}],
            totalCount: 0,
            resetPagination: false,
        });
        const selectedBrand = computed(() => store.state.auth.selectedBrand?.brand);
        watch(selectedBrand, () => {
            state.resetPagination = true;
            fetchTableData(1);
        });
        onMounted(() => {
            bus.$on('render-page-loader', isActive => {
                loadingExport.value = isActive;
            });
        });
        onBeforeUnmount(() => {
            bus.$off('render-page-loader');
        });
        const getMenuItems = computed(() => {
            return Object.keys(state.data || []).length ? Object.entries(state.data) : [];
        });
        const onItemSelected = (item) => {
            state.item = item;
        };
        const fetchTableData = (page = 1) => {
            isLoading.value = true;
            hasError.value = false;
            fetchDataIngestionHistory({
                page,
            })
                .then(response => {
                state.columns = response?.series;
                state.data = response?.data;
                state.totalCount = response?.totalCount;
                const date = Object.entries(state.data)[0][0];
                const item = Object.entries(state.data)[0][1];
                state.item = [date, item];
                useMixpanelDataIngestionHistory('view_integrations_data-ingestion-history_init', date, item.status);
            })
                .catch(() => {
                hasError.value = true;
            })
                .finally(() => {
                isLoading.value = false;
                setTimeout(() => {
                    state.resetPagination = false;
                }, 1000);
            });
        };
        fetchTableData();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createVNode(DataIngestionHistoryMenu, {
                    onItemSelected: onItemSelected,
                    onFetchData: fetchTableData,
                    loading: isLoading.value,
                    error: hasError.value,
                    items: getMenuItems.value,
                    totalCount: state.totalCount,
                    "reset-pagination": state.resetPagination,
                    class: "data-ingestion-history__menu"
                }, null, 8, ["loading", "error", "items", "totalCount", "reset-pagination"]),
                _createVNode(DataIngestionHistoryCard, {
                    data: state.item,
                    columns: state.columns,
                    loading: isLoading.value,
                    error: hasError.value
                }, null, 8, ["data", "columns", "loading", "error"]),
                _withDirectives(_createVNode(BaseLoader, {
                    color: "colored-block",
                    class: "render-loader"
                }, null, 512), [
                    [_vShow, loadingExport.value]
                ])
            ]));
        };
    }
});
